import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconUse", "isToolbarActive", "isTrellisTheme", "variant"];
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { TOOLBAR_DROPDOWN_ICON_BUTTON_WIDTH } from './constants';
import ToolbarIconButton from './ToolbarIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarDropdownIconButton = props => {
  const {
      iconUse,
      isToolbarActive,
      isTrellisTheme,
      variant
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(ToolbarIconButton, Object.assign({}, rest, {
    borderInlineEndWidth: "100",
    borderInlineStartWidth: "100",
    icon: DownCaratIcon,
    isToolbarActive: isToolbarActive,
    width: TOOLBAR_DROPDOWN_ICON_BUTTON_WIDTH,
    use: iconUse,
    variant: variant === 'aiEditor' ? 'aiEditor' : 'dropdown',
    isTrellisTheme: isTrellisTheme
  }));
};
export const TrellisToolbarDropdownIconButton = ToolbarDropdownIconButton;
export default TrellisToolbarDropdownIconButton;